// extracted by mini-css-extract-plugin
export var container = "LocaleDialog-module--container--72f47";
export var linkList = "LocaleDialog-module--linkList--11d7d";